var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    display: "block"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.302 9.709v-4.55c0-.81-.662-1.474-1.471-1.474h-4.548L15.03.431a1.466 1.466 0 00-2.075 0L9.702 3.685H5.155c-.81 0-1.472.663-1.472 1.473v4.55L.43 12.964a1.467 1.467 0 000 2.077l3.253 3.255v4.55c0 .81.662 1.473 1.472 1.473h4.547l3.253 3.255c.294.294.662.427 1.045.427.383 0 .75-.147 1.045-.427l3.252-3.255h4.548c.81 0 1.472-.663 1.472-1.473v-4.55l3.253-3.255a1.467 1.467 0 000-2.076l-3.253-3.255h-.015zM12.528 19.03l-3.988-3.99 2.075-2.078 1.899 1.9 4.842-4.845 2.075 2.077-6.932 6.936h.03z",
    fill: "var(--fill-0, #00D0B2)"
  })));
}
export default SvgPartnerCheckIcon;